import { FC } from "react";
import { Loading02 } from "untitledui-js-base";

export const ProgressReportView: FC<{
  message?: string;
}> = ({ message }) => {
  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex max-w-md flex-col items-center justify-center gap-6 p-6">
        <div className="flex h-16 w-16 items-center justify-center rounded-full bg-warning-50">
          <Loading02 size="20px" className="stroke-warning-500" />
        </div>

        <p className="text-center text-sm font-medium text-content-300">
          {message || "Report in progress. Please wait"}
        </p>
      </div>
    </div>
  );
};
